// extracted by mini-css-extract-plugin
module.exports = {"hide_modal":"BanModal_hide_modal__4GMzG","modal":"BanModal_modal__96eez","content":"BanModal_content__zCsks"};